import type { AgendaKind } from "@msc/shared";

/**
 * Nur der Teil von `t`, den hier jemand braucht — so bleibt die Funktion ohne
 * React prüfbar und zwingt keinen Aufrufer zu einem bestimmten i18n-Typ.
 */
type Translate = (key: string) => string;

/**
 * Der Vorgabetitel eines Agenda-Punkts: „Neuigkeiten", „Wartung", „Budget".
 *
 * Er existiert, weil ein Titel leer sein KANN — der Lead darf das Feld in der
 * Vorbereitung und im Cockpit ausräumen, und `agendaItemSchema` (`.trim()`
 * vor `min(1)`) lehnt genau das später ab. Ohne Rückfall stünde auf der Bühne
 * eine leere Überschrift und im Ergebnisprotokoll, das der Kunde behält, eine
 * Zeile ohne Namen.
 */
export function agendaTitleFallback(kind: AgendaKind, t: Translate): string {
  return t(`pages.customerView.present.agendaKind.${kind}`);
}

/**
 * Der anzuzeigende Titel eines Punkts — der eigene, sonst der Vorgabetitel.
 * Eine Stelle für alle Anzeigen (Agenda-Spalte, Bühne, „Als Nächstes",
 * Protokoll), damit nicht drei Fassungen davon entstehen, was „leer" heißt.
 */
export function agendaTitleOf(item: { kind: AgendaKind; title: string }, t: Translate): string {
  return item.title.trim() === "" ? agendaTitleFallback(item.kind, t) : item.title;
}
